import config from '../config'
import { debug } from '../utilities/logger'
import { injectScript } from '../utilities/window'

(() => {
  if (!config['vendors-activated']) {
    return debug(`[vendors][Zendesk] Deactivated cause not in production`)
  }
  injectScript({ url: `https://v2.zopim.com/?${config['zendesk-key']}`, isAsync: true })
})()



// WEBPACK FOOTER //
// ./src/vendors/Zendesk.js